export default __webpack_public_path__ + "static/media/dashboardIcon.4d7fb9f4.svg";